import { z } from 'zod';

export const CollectionMethodSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1),
    description: z.string().optional(),
    parentId: z.string().nullable().optional(),
    processingCategory: z.enum(['fully_automatic', 'partially_automatic', 'non_automatic']).optional(),
    thirdPartySource: z.string().optional(),
    orderIndex: z.number().optional(),
    status: z.enum(['active', 'inactive']).optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateCollectionMethodSchema = CollectionMethodSchema.omit({ id: true });
export const UpdateCollectionMethodSchema = CollectionMethodSchema.partial();
export const CollectionMethodFormSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1, 'form.validation.nameRequired'),
    description: z.string().min(1, 'form.validation.descriptionRequired'),
});
